// Reps : marqueur LOCAL « j'ai déjà joué aujourd'hui » (parité app mobile,
// où il vit dans le store de l'appareil sous lastActivityDay).
//
// Il ne remplace pas le serveur, qui reste seul maître de la série : il sert
// uniquement à décider s'il faut MONTRER l'écran de célébration, sans attendre
// la réponse du submit. Sans lui, une réponse lente ou perdue privait
// l'apprenant de sa célébration alors que sa série avait bien grimpé.
//
// Le jour est celui du navigateur, comme sur mobile : c'est le même
// référentiel que celui que l'apprenant a sous les yeux.

const KEY = "reps_last_activity_day";

function todayKey() {
    const d = new Date();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${m}-${day}`;
}

/** A-t-on déjà terminé une leçon aujourd'hui sur ce navigateur ? */
export function hasDoneRepsToday() {
    if (typeof window === "undefined") return false;
    try {
        return window.localStorage.getItem(KEY) === todayKey();
    } catch (e) {
        // Stockage indisponible : on se rabat sur le serveur (pas de
        // célébration plutôt qu'une célébration en double).
        return true;
    }
}

/** Marque la journée comme jouée (appelé à l'affichage du récap de fin). */
export function markRepsActivityToday() {
    if (typeof window === "undefined") return;
    try {
        window.localStorage.setItem(KEY, todayKey());
    } catch (e) {
        // sans conséquence : la série reste juste côté serveur
    }
}
